import { useTranslation } from 'react-i18next'

import { useScreen } from '../../../../../hooks'
import { FormikField } from '../../../../Formik'
import { InputField } from '../../../../Input'
import {
  USER_FORM_EXTERNAL_ID_FIELD_MAX_LENGTH,
  USER_FORM_FIELD_NAME_EXTERNAL_ID,
} from '../../../../User'

import * as styles from '../InhabitantFormFields.module.css'

function ExternalIdField() {
  const { t } = useTranslation()

  const { isMobileScreenSize } = useScreen()

  return (
    <FormikField
      hasCounter
      Component={InputField}
      borderless={!isMobileScreenSize}
      fieldComponentProps={{
        label: `${t('Inhabitant.ExternalIdLabelKey')}:`,
        shouldAdaptToMobileScreen: true,
      }}
      inline={isMobileScreenSize}
      maxLength={USER_FORM_EXTERNAL_ID_FIELD_MAX_LENGTH}
      name={USER_FORM_FIELD_NAME_EXTERNAL_ID}
      placeholder={t('Inhabitant.ExternalIdPlaceholderKey')}
      wrapperClassName={styles.fieldWrapper}
    />
  )
}

export default ExternalIdField
